/**
 * Debounce function.
 *
 * @param {Function} func The function to run.
 * @param {number}   wait The debounce time.
 *
 * @return {Function} The debounced function.
 */
const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

/**
 * Utility to prevent default triggering on an event.
 *
 * @param {Event} e The triggered event.
 *
 * @return {void}
 */
const preventSummaryClick = (e) => {
  e.preventDefault();
};

/**
 * Disable default <details> functionalty for larger screens.
 *
 * @param {NodeList} footerDetails The NodeList of footer <details> elements.
 *
 * @return {void}
 */
const disableFooterDetailsForDesktop = (footerDetails) => {
  footerDetails.forEach((detail) => {
    const summary = detail.querySelector('summary');

    if (!summary) return;

    detail.setAttribute('open', '');
    summary.setAttribute('aria-disabled', 'true');
    summary.setAttribute('tabindex', '-1');

    summary.addEventListener('click', preventSummaryClick);
  });
};

/**
 * Resumes default <details> functionalty for smaller screens.
 *
 * @param {NodeList} footerDetails The NodeList of footer <details> elements.
 *
 * @return {void}
 */
const enableFooterDetailsForMobile = (footerDetails) => {
  footerDetails.forEach((detail) => {
    const summary = detail.querySelector('summary');

    if (!summary) return;

    detail.removeAttribute('open');
    summary.removeAttribute('aria-disabled');
    summary.removeAttribute('tabindex');
    summary.removeEventListener('click', preventSummaryClick);
  });
};

/**
 * Determine the required state for <detail> elements in the footer.
 *
 * @return {void}
 */
const determineFooterDetailsState = () => {
  const windowWidth = window.innerWidth;
  const footerDetails = document.querySelectorAll('footer .footer-nav details');

  if (!footerDetails.length) return;

  if (windowWidth > 781) {
    disableFooterDetailsForDesktop(footerDetails);
  } else {
    enableFooterDetailsForMobile(footerDetails);
  }
};

window.addEventListener('DOMContentLoaded', () => {
  determineFooterDetailsState();
});

window.addEventListener(
  'resize',
  debounce(() => {
    determineFooterDetailsState();
  }, 100),
);
